import styled from 'styled-components';

export const StyledBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
`;

export const StyledSpan = styled.span`
  color: gray;
`;

export const StyledBoldSpan = styled.span`
  font-size: 1.2rem;
  letter-spacing: 0.2rem;
  text-transform: capitalize;
  font-weight: 500;
`;
